import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import initPlugins from '@/common/plugins';
import getRouter from '@/self-service/routes';
import { store } from '@/common/root';
import init from '@/self-service/initSelfService';
import Application from '@/common/application';
import { createPinia, mapState, mapStores, PiniaVuePlugin } from 'pinia';
import wsPlugin from '@/common/store/plugins/wsPlugin';
import useAuthStore from '@/common/store/pinia/auth';
import { initApi } from '@/common/utils/api';
import initSubscriptions from '@/common/utils/subscriptions';
import initializeTelemetry from '@/common/utils/telemetry/telemetryInit';
import App from './SelfServiceApp.vue';

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(wsPlugin);
const router = getRouter(pinia);
sync(store, router, { moduleName: 'routes' });

initializeTelemetry();

initApi(useAuthStore(pinia), store);
initPlugins(pinia);
initSubscriptions();

init(pinia).finally(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    components: { App },
    extends: Application,
    router,
    pinia,
    computed: {
      ...mapStores(useAuthStore),
      ...mapState(useAuthStore, ['currentUser'])
    },
    watch: {
      currentUser(value) {
        if (!value) {
          const redirectUrl = this.$route.query.redirectUrl
            || this.$route.fullPath;
          const currentDomain = typeof window !== 'undefined' && window.localStorage.getItem('domain');
          const idpId = this.authStore.currentIdpId;
          const routeParam = {
            path: `/login/${currentDomain || ''}`
          };
          if (routeParam.path !== redirectUrl) {
            routeParam.query = { redirectUrl };
          }

          if (idpId !== null) {
            routeParam.path = `/login/${currentDomain || ''}/${idpId}`;
            routeParam.query.logout = true;
          }
          this.authStore.resetIdpId();
          this.$router.push(routeParam);
        }
      }
    },
    render: h => h(App)
  });
});
